module.exports = __webpack_public_path__ + "static/media/circle.3aa078f7.svg";